export const ACCOUNT_URL = `${process.env.NEXT_PUBLIC_STACKUP_HOST}/web/my/account`
export const DEFAULT_BANNER_URL =
  process.env.NEXT_PUBLIC_DEFAULT_BANNER_URL || '/images/banners/banner.png'
